import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import { AvailablePhoneNumberInterface } from '../../store/callrecorder/availablePhoneNumbersSlice';

const PREFIX = 'callrecorder';

export const availablePhoneNumbersEntity = new schema.Entity(
  'available_phone_numbers',
  {},
  {
    idAttribute: 'uid'
  }
);

export const fetchAvailablePhoneNumbers = createAsyncThunk(
  `${PREFIX}_available_phone_numbers/fetchAvailablePhoneNumbers`,
  async (params: object = {}) => {
    const response = await callrecorderApi.get('/onesky/available_phone_numbers', { params });
    const normalized = normalize<
      any,
      {
        available_phone_numbers: { [key: string]: AvailablePhoneNumberInterface };
      }
    >(response.data.available_phone_numbers, [availablePhoneNumbersEntity]);

    return {
      availablePhoneNumbers: normalized.entities?.available_phone_numbers || {},
      ids: normalized.result
    };
  }
);

export const fetchAvailablePhoneNumberCountries = createAsyncThunk(
  `${PREFIX}_available_phone_numbers/fetchAvailablePhoneNumberCountries`,
  async (params: object = {}) => {
    const response = await callrecorderApi.get('/onesky/available_phone_numbers/countries', { params });
    return response.data.countries || [];
  }
);
